import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppContext = createContext();

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem("bb_lang") || "en");
  const [currency, setCurrency] = useState(localStorage.getItem("bb_currency") || "USD");
  const [country, setCountry] = useState(localStorage.getItem("bb_country") || "US");

  useEffect(() => {
    const token = localStorage.getItem("bb_token");
    if (token) {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem("bb_token")).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    // Attempt IP geolocation to auto-set country/currency
    if (!localStorage.getItem("bb_country")) {
      fetch("https://ipapi.co/json/")
        .then((r) => r.json())
        .then((d) => {
          if (d && d.country_code) {
            setCountry(d.country_code);
            localStorage.setItem("bb_country", d.country_code);
            if (d.currency && ["USD","EUR","GBP","CAD","AUD","INR"].includes(d.currency)) {
              setCurrency(d.currency);
              localStorage.setItem("bb_currency", d.currency);
            }
          }
        })
        .catch(() => {});
    }
  }, []);

  useEffect(() => { localStorage.setItem("bb_lang", language); }, [language]);
  useEffect(() => { localStorage.setItem("bb_currency", currency); }, [currency]);
  useEffect(() => { localStorage.setItem("bb_country", country); }, [country]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bb_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("bb_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (_) { return null; }
  };

  const logout = () => {
    localStorage.removeItem("bb_token");
    setUser(null);
  };

  return (
    <AppContext.Provider value={{
      user, loading, login, signup, logout, refresh,
      language, setLanguage, currency, setCurrency, country, setCountry,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
